<template>
<div>
    <div class="mcc-page-header">
        <div>
            <div class="mu-d-flex">
                <h1 class="mu-mb-00">External system API</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Integrate</li>
                    <li>
                        <a class="linkCode" @click="redirectToList()">External systems</a>
                    </li>
                    <li>
                        <router-link  class="linkCode" :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId">{{externalSystem.name}}</router-link>
                    </li>
                    <li aria-current="page">Create new</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06">
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-row" v-if="fetchCall">
                <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="externalSystemReadOnly" v-if="isReadOnly">
                    <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                    <span>
                        <strong>Warning!</strong>
                        <br />{{readOnlyMsg}}
                        <br />
                    </span>
                </mcc-alert>
                <div>
                    <div style="position:relative">
                        <div v-if="!updateCallAPI" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <form ref="externalSystemAPIForm" @submit.prevent="saveExternalSystemAPI()" id="formId" novalidate>
                            <div class="mcc-card">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">API</h2>
                                </div>
                                <div class="mcc-card__body">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03 mfc-form-input-wrapper--width">
                                                <label for="name" class="mfc-label--required mu-mb-00">Name</label>
                                                <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" :disabled="isReadOnly" ref="name" :value="dto.name" :pattern="nameRegex" @change="updateName($event)">
                                            </div>
                                            <div class="mfc-slim-select-wrapper mfc-form-input-container mu-mb-03 mfc-form-input-wrapper--width">
                                                <label for="connectionType-selectId" class="mfc-label--required mu-mb-00">Connection Type</label>
                                                <select :disabled=isReadOnly required @change="updateHelpUrl($event)" ref="connectionTypeRef" name="connectionType-select" id="connectionType-selectId" class="mfc-slim-select mu-mt-00">
                                                    <option value="">Select your option</option>
                                                    <option v-if="!disableSQL" value="DATABASE">DATABASE</option>
                                                    <option v-if="!disableRest" value="REST">REST</option>
                                                    <option v-if="!disableFile" value="FILE">FILE</option>
                                                </select>
                                            </div>
                                            <div class="mfc-input-wrapper mu-d-block form-input-container mfc-form-input-wrapper--width" v-if="dto.connectionType=='REST'">
                                                <label for="helpId">Rest API Help Documentation</label>
                                                <input type="text" id="helpId" name="helpName" placeholder="Rest API help documentation" maxlength="100" :disabled="isReadOnly"  @change="dto.helpURL = $event.target.value" ref="dto.helpId" :value="dto.helpURL" :pattern="helpDocumentationES">
                                            </div>
                                            <div class="mu-d-flex mu-justify-content-end mu-mt-05">
                                                <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/'+externalSystemId">
                                                    <button class="mcc-button mcc-button--outline mu-mr-05" id="cancelBtn" title="Cancel" type="button">
                                                        <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                    </button>
                                                </router-link>
                                                <button class="mcc-button mcc-button--success" v-if="!isReadOnly" title="Save" id="saveBtn" type="submit">
                                                    <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid';

export default {
    name: "ExternalSystemAPICreate",
    data() {
        return {
            dto: {
                connectionType: "DATABASE"
            },
            externalSystem: {},
            updateCallAPI: true,
            nameRegex: constantMessages.PATTERNS["name"],
            helpDocumentationES: constantMessages.PATTERNS["helpDocumentationES"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["externalsystemAPI.create"],
            externalSystemId: this.$route.params.externalSystemId,
            connectionType: [],
            fetchCall: true,
            disableRest: false,
            disableFile: false,
            disableSQL: false,
            isReadOnly: false,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"]
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;

        ExternalSystemAPI.getExternaSystemInfoWithConnType(self.externalSystemId)
            .then(result => {
                if (result == null || result == "") {
                    self.$router.push(
                        self.CONTEXT_PATH + "/integrate/externalsystems"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching external system API"
                    });
                    return;
                }
                self.dataLoaded = true;
                self.externalSystem = result.externalSystem;
                self.isReadOnly = self.externalSystem.readOnly;
                self.connectionType = result.importType;
                if (result.disabledExternalSystems != null && result.disabledExternalSystems != "") {
                    self.disableRest = result.disabledExternalSystems.indexOf("REST") != -1;
                    self.disableFile = result.disabledExternalSystems.indexOf("FILE") != -1;
                    self.disableSQL = result.disabledExternalSystems.indexOf("DATABASE") != -1;
                }
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.systemApi.details"] + " - Create new";
                EventBus.$emit("update-pageTitle", pageTitle);
            }).finally(function () {
                self.fetchCall = true;

            });
        new SlimSelect({
            select: '#connectionType-selectId',
        });
    },
    methods: {
        handleValidation() {
            let invalid = false;
            let self = this;
            if (!this.dto?.name) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
                invalid = true;
            }
            return invalid;
        },
        saveExternalSystemAPI() {
            let form = $('#formId')
            let self = this;
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            self.updateCallAPI = false;
            ExternalSystemAPI.saveExternalSystemAPI(self.externalSystem.id, this.dto).then(response => {
                self.updateCallAPI = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    this.$router.push(this.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystem.id + "/apis/" + response.data.id).catch(err => {});
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.dto.name = event.target.value;
        },
        updateHelpUrl(event) {
            let self = this;
            self.dto.connectionType = event.target.value;
            if (self.dto.connectionType != "REST") {
                self.dto.helpURL = "";
            }
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(
                this.CONTEXT_PATH + '/integrate/externalsystems'
            );
        }
    }
};
</script>